import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import CalculationResultPart from '../../components/CalculationResultPart';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import LocalDatePicker from '../../components/LocalDatePicker';
import { differenceInDays, differenceInYears } from "date-fns";
import Dropdown from '../../components/Dropdown';
import Header from '../../components/Header';

const faqs = [
    {
        question: "<h5>Yıllık İzin: Haklarınız ve Kullanım Şekli</h5>",
        answer: ["Yıllık izin, işçilerin iş yerinden ücretli olarak uzaklaşabildiği ve dinlenme hakkını kullanabildiği bir dönemdir. Bu süre boyunca maaşınız kesintiye uğramaz. Peki yıllık izin hakkını kazanmak için ne kadar süre çalışmak gerekir ve izin süresi nasıl hesaplanır?"],
    },
    {
        question: "<h5>Yıllık İzin Süresi Nasıl Hesaplanır?</h5>",
        answer: ["4857 sayılı İş Kanunu, yıllık izin hakkını çalışanın yaşına ve kıdemine (çalışma süresine) göre belirler. Kanun, belirli bir çalışma süresini dolduran ve belirli bir yaşın üzerinde olan çalışanların daha fazla dinlenme hakkına sahip olmasını gözetmektedir."],
    },
    {
        question: "<h5>Çalışma Süresine Göre Yıllık İzin Süreleri (2024):</h5>",
        answer: [
            "1 yıldan 5 yıla kadar (5 yıl dahil): 14 gün",
            "5 yıldan fazla 15 yıla kadar (15 yıl hariç): 20 gün",
            "15 yıl ve üzeri: 26 gün",
        ],
    },
    {
        question: "<strong>Örnek:</strong> Bir iş yerinde 3 yıl 2 ay çalışan bir kişi 14 günlük yıllık izin hakkına sahiptir. Çünkü bu kişinin hizmet süresi 5 yıla ulaşmamıştır.",
    },
    {
        question: "<h5>Yaşa Göre Yıllık İzin Süresi:</h5>",
        answer: ["18 yaşından küçükler ve 50 yaşından büyükler: 20 gün ve üzeri"],
    },
    {
        question: "<h5>Yıllık İzin Hakkı Ne Zaman Başlar?</h5>",
        answer: ["İşyerinde çalışmaya başladığınız günden itibaren deneme süresi de dahil olmak üzere en az bir yıl çalıştıktan sonra yıllık izin hakkını kazanırsınız. Örneğin, 01.03.2023 tarihinde işe başlayan bir çalışan için deneme süresi 30 gün olsun. Bu çalışanın bir yıllık bekleme süresi 01.02.2024 tarihinde dolacaktır. Dolayısıyla bu kişi 01.02.2024'ten itibaren yıllık izin kullanabilir."],
    },
    {
        question: "<h5>Yıllık İzin Hakkı Hangi Koşullarda Geçerli Değildir?</h5>",
        answer: ["Yıllık izin hakkı, mevsimlik işlerde veya kampanya gibi belirli bir süre için yapılan işlerde çalışanlar için geçerli değildir. Bu tür işler dışında çalışanlar 1 yıllık çalışma süresini doldurduktan sonra yıllık izin kullanabilir."],
    },
    {
        question: "<h5>Kıdem Hesaplanırken Deneme Süresi Dahil mi?</h5>",
        answer: ["Evet, kıdem hesaplarken iş sözleşmesindeki deneme süresinin başlangıç tarihi işe başlama tarihi olarak kabul edilir ve çalışma süresine dahil edilir."],
    },
    {
        question: "<h5>Yıllık İzin Hakkından Vazgeçilebilir mi?</h5>",
        answer: ["Hayır. Yıllık izin hakkı Anayasal bir hak olduğundan vazgeçilemez. Bu hakkın kullanılmaması işveren tarafından talep edilemez veya işçi bu hakkından vazgeçtiğini belirten bir dilekçe veremez."],
    },
];

const sektorOptions = [{ text: "Kamu Çalışanıyım", value: 1 }, { text: "Özel Sektör Çalışanıyım", value: 2 }];

const IsGunuHesaplama = () => {
	const [hideAll, setHideAll] = useState(false);
	const [results, setResults] = useState([]);
	const [calculated, setCalculated] = useState(false);

	const [dogumTarihi, setDogumTarihi] = useState(null);
	const [iseGirisTarihi, setIseGirisTarihi] = useState(null);
	const [isSektoru, setIsSektoru] = useState(null);

	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const query = new URLSearchParams(location.search);

		if (query.toString()) {
			const parsedResults = query.get('results');
			if (parsedResults) {
				setResults(JSON.parse(decodeURIComponent(atob(parsedResults))));
			}
            setIseGirisTarihi(new Date(decodeURIComponent(atob(query.get('iseGirisTarihi')))));
            setDogumTarihi(new Date(decodeURIComponent(atob(query.get('dogumTarihi')))));
            setIsSektoru(Number(decodeURIComponent(atob(query.get('isSektoru')))));
			setCalculated(true);
		}
        
		localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
	}, [location.search]);

	const calculate = () => {
		if (dogumTarihi && iseGirisTarihi && isSektoru) {
            let result;
            const age = differenceInYears(new Date(), dogumTarihi);
            const work_year = Math.abs(differenceInDays(iseGirisTarihi, new Date())) / 365;

            if (isSektoru === 1) {
                result = 20;

                if (work_year > 10) {
                    result = 30;
                }
            }
            else {
                result = 14;

                if (work_year > 5) {
                    result = 20;
                }
                else if (work_year > 15) {
                    result = 26;
                }
            }

            if (age < 18 || age > 50) {
                result = Math.max(20, result ?? 0);
            }

            const newResults = [{ text: "Yıllık İzin Süreniz", value: result }];

            setHideAll(true);

            const params = new URLSearchParams({
				results: btoa(encodeURIComponent(JSON.stringify(newResults))),
				iseGirisTarihi: btoa(encodeURIComponent(new Date(iseGirisTarihi).toISOString())),
				dogumTarihi: btoa(encodeURIComponent(new Date(dogumTarihi).toISOString())),
                isSektoru: btoa(encodeURIComponent(isSektoru.toString())),
			});

			navigate(`${window.location.pathname}?${params.toString()}`);
			navigate(0);
		} else {
			alert("Lütfen tüm değerleri doğru girdiğinizden emin olunuz!");
		}
	};

    return (
        <>
            <Helmet>
                <title>Yıllık İzin Süresi Hesaplama - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Yıllık izin, işçilerin dinlenmeleri amacıyla her yıl belirli bir süre boyunca ücretli olarak verilen izindir. İşçinin çalışma süresine göre farklılık gösterir ve kanunen korunur." />
            </Helmet>
            
            <Header />
            <section className="container my-5 bg-white shadow-sm p-0">
                <div className="p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        <li>Yıllık İzin Süresi Hesaplama</li>
                    </ol>
                    <h1 className="fw-semibold">Yıllık İzin Süresi Hesapla</h1>
                    <p>Yıllık izin, işçilerin dinlenmeleri amacıyla her yıl belirli bir süre boyunca ücretli olarak verilen izindir. İşçinin çalışma süresine göre farklılık gösterir ve kanunen korunur.</p>
                    
                    <LocalDatePicker label="Doğum Tarihiniz" setValue={setDogumTarihi} value={dogumTarihi} />
                    <LocalDatePicker label="İşe Başlama Tarihiniz" setValue={setIseGirisTarihi} value={iseGirisTarihi} />

                    <Dropdown label="Çalışmakta Olduğunuz Sektör" options={sektorOptions} selectedOption={isSektoru} setSelectedOption={setIsSektoru} />
                </div>

                <CalculationResultPart calculated={calculated} hideAll={hideAll} results={results} calculate={calculate} trailText='gün' />
            </section>
            
            <Footer faqs={faqs} faqTitle="Yıllık İzin Süresi Hakkında Bilmeniz Gerekenler" />
        </>
    );
};

export default React.memo(IsGunuHesaplama);
